<template>
  <div>
    <div id="app">
      <router-view/>
    </div>
  <!--   <div style="padding-top:10%;">
      <footer class="app-footer section is-medium">
        <div class="container">
          <div class="columns">
            <div class="column is-5 is-4-widescreen">
              <div class="summary">
                
                <a
                  href="http://www.littlelightsstudio.com"
                  target="_blank"
                >2019 &copy Travelaam Holidays</a>
              </div>
            </div>
            <div class="column is-7 is-6-widescreen is-offset-2-widescreen">
              <div class="columns">
                <div class="column is-4">
                  <div class="menu">
                    <p class="menu-label">Product</p>
                    <ul class="menu-list">
                      <li>
                        <a href="/">Home</a>
                      </li>
                      <li>
                        <a href="/school">
                          Storytelling School
                          <span class="tag is-warning is-micro is-uppercase">New</span>
                        </a>
                      </li>
                      <li>
                        <a href="/library">Library</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="menu">
                    <p class="menu-label">Company</p>
                    <ul class="menu-list">
                      <li>
                        <a href="https://medium.com/bedtime-stories-blog">Blog</a>
                      </li>
                      <li>
                        <a href="/about-us">About Us</a>
                      </li>
                      <li>
                        <a href="/about-us#downloads">Press Kit</a>
                      </li>
                      <li>
                        <a href="/imprint">Imprint</a>
                      </li>
                      <li>
                        <a href="/privacy">Privacy</a>
                      </li>
                      <li>
                        <a href="/terms">Terms</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="menu">
                    <p class="menu-label">Connect with us</p>
                    <ul class="menu-list">
                      <li>
                        <a href="https://facebook.com/getbedtimestories" target="_blank">
                          <img
                            role="presentation"
                            src="/assets/images/icons/social/facebook-f18752b0.svg?1547214151"
                          >Facebook
                        </a>
                      </li>
                      <li>
                        <a href="https://messenger.com/t/1180441035357755" target="_blank">
                          <img
                            role="presentation"
                            src="/assets/images/icons/social/messenger-d2bb944d.svg?1547214151"
                          >Messenger
                        </a>
                      </li>
                      <li>
                        <a href="https://instagram.com/getbedtimestories" target="_blank">
                          <img
                            role="presentation"
                            src="/assets/images/icons/social/instagram-89cb51bf.svg?1547214151"
                          >Instagram
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/getbedtimestory" target="_blank">
                          <img
                            role="presentation"
                            src="/assets/images/icons/social/twitter-42c2f562.svg?1547214151"
                          >Twitter
                        </a>
                      </li>
                      <li>
                        <a href="https://medium.com/bedtime-stories-blog" target="_blank">
                          <img
                            role="presentation"
                            src="/assets/images/icons/social/medium-2fc70afa.svg?1547214151"
                          >Medium
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="scss">
.button {
  width: 100%;
  background: linear-gradient(233deg, #5e005e, #eb014f);
}
.menu-label {
  color: #5e005e;
  font-size: 2em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.menu-label:not(:first-child) {
  margin-top: 1em;
}
.menu-label:not(:last-child) {
  margin-bottom: 1em;
}
.brand-icon {
  //width: 56px;
  height: 50px;
  margin-right: 0rem;
  transition-duration: 172ms;
  will-change: width, height, margin-right;
}
.brand .brand-icon img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.menu-label {
   color: #5e005e;
  font-size: 1.375rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}
.menu-label:not(:last-child) {
  margin-bottom: 0.5rem;
}
.menu-list {
  margin-left: -0.75rem;
  font-size: 1.125rem;
}
.menu-list .tag {
  position: relative;
  top: -10px;
  left: -4px;
}
.menu-list img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 1rem;
}
// Import Bulma's core
// @import "~bulma/sass/utilities/_all";

// Set your colors
/*   $primary: linear-gradient(233deg, #eb014f, #5e005e, #eb014f);
  $primary-invert: findColorInvert($primary); */

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
/*  $colors: (
      "white": ($white, $black),
      "black": ($black, $white),
      "light": ($light, $light-invert),
      "dark": ($dark, $dark-invert),
      "primary": ($primary, $primary-invert),
      "info": ($info, $info-invert),
      "success": ($success, $success-invert),
      "warning": ($warning, $warning-invert),
      "danger": ($danger, $danger-invert)
  );  */

// Links
/* $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary; */

// Import Bulma and Buefy styles
// @import "~bulma";
//@import "~buefy/src/scss/buefy";
@import './sass/app';

#app {
  background-color: #ffffff !important;
  height: 100%;
  @import 'https://fonts.googleapis.com/css?family=Nunito';
  font-family: 'Nunito', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue